<div class="container">
  <header class="page-heading mb-lg">
    <span class="legal-eyebrow"><app-icon name="menu_book" class="eyebrow-icon"/> Learn</span>
    <h1>Money guides for smarter finances in India</h1>
    <p>
      Plain-language guides on tax, loans, savings and retirement planning — each one links
      straight to the calculator you need to run your own numbers.
    </p>
  </header>

  <div class="article-grid">
    @for (a of articles; track a.slug) {
      <a class="article-card" [routerLink]="['/learn', a.slug]">
        <span class="legal-eyebrow"><app-icon [name]="a.eyebrowIcon" class="eyebrow-icon"/> {{ a.eyebrow }}</span>
        <h2>{{ a.title }}</h2>
        <p>{{ a.summary }}</p>
        <span class="article-card-meta"><app-icon name="schedule" class="meta-icon"/> {{ a.readingTime }}</span>
      </a>
    }
  </div>
</div>
